import styled from "styled-components";

export const OrganizacjeEdycjaStyle = styled.div`
  height: 100%;
  max-width: 1018px;
  display: grid;
  grid-template-rows: 72px auto 1fr;
  grid-gap: 8px;

  header {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 116px;
  }

  form {
    display: grid;    
    grid-gap: 16px;
    height: fit-content;

    section {
      background-color: ${(props) => props.theme.palette.background.paper};
      padding: 16px 20px;
      display: grid;
      grid-gap: 20px;
      height: fit-content;

      .switch {
        display: grid;
        grid-template-columns: 1fr auto;
      }
    }
  }
`;
